import { useContext, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeContext } from "../context/ThemeContext";

/**
 * Syncs MUI palette with app data-theme so dialogs, inputs, and alerts match CSS variables.
 */
function AppMuiThemeProvider({ children }) {
  const { effectiveTheme } = useContext(ThemeContext);
  const mode = effectiveTheme === "dark" ? "dark" : "light";

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: { main: "#6366f1", dark: "#4f46e5", light: "#818cf8" },
          secondary: { main: "#818cf8" },
          error: { main: "#ef4444" },
          success: { main: "#10b981" },
          warning: { main: "#f59e0b" },
          divider: mode === "dark" ? "rgba(148, 163, 184, 0.22)" : "#e2e8f0",
          background: {
            default: mode === "dark" ? "#0c0d10" : "#f3f4f6",
            paper: mode === "dark" ? "#14151a" : "#ffffff",
          },
          text: {
            primary: mode === "dark" ? "#f1f5f9" : "#0f172a",
            secondary: mode === "dark" ? "#94a3b8" : "#64748b",
          },
        },
        typography: {
          fontFamily: '"Inter", "Nunito Sans", sans-serif',
        },
        shape: { borderRadius: 8 },
      }),
    [mode]
  );

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

export default AppMuiThemeProvider;
